<template src="./template.html" ></template>

<script>
import MyAlert from '../../components/alert/MyAlert.vue'
import MyListButtons from '../add/Buttons.vue'
import MyNumber from '../../components/MyNumber.vue'
import MyBanks from '../../components/MyBanks.vue'
import MyCurrency from '../../components/MyCurrency.vue'
import MyComment from '../../components/MyComment.vue'

export default {
  name: 'bank_account-items',
  props: ['formTitle'],
  data() {
    return {
      valid: false,
      alert: false,
      model: {
        disabled: false,
        init: {
          items: {
            //     price: null
          }
        }
      },
      requiredRules: [
        v => !!v || 'فیلد اجباری',
      ],
    }
  },
  async beforeCreate() {
    this.formState = this.$router.currentRoute.path.split("/")[2]
    this.route = this.$store.getters.pageInfo.route
    if (this.formState === 'edit') {
      let _mid = this.$router.currentRoute.path.split("/")[3]
      let data = {
        url: `/api/${this.route}`,
        params: {
          mid: _mid
        },
      }
      await this.$store.dispatch('getInfo', data)
      this.model = this.$store.getters.editData
      // console.log(this.model);
    }
  },
  methods: {
    async set3zero(item) {
      if (item) {
        this.model.init.items.price = item
      }
    },
    async onSave() {
      //
      let _method = 'POST'
      if (this.formState === 'edit') {
        _method = 'PUT'
      }
      this.$refs.form.validate()
      let _data = {
        method: _method,
        url: `/api/${this.route}`,
        data: {
          data: this.model
        },
      }
      if (this.valid) {
        await this.$store.dispatch('save', _data)
        let res = this.$store.getters.saveData
        if (res && (res.insert || res.update)) {
          this.alert = true
        }
      }
    },
  },
  components: {
    MyAlert,
    MyListButtons,
    MyNumber,
    MyBanks,
    MyCurrency,
    MyComment,
  },
}
</script>
<style lang="scss">
#numeric {
    font-family: b_yekan;
    font-size: 18px;
}
</style>
